import { Permissions } from '../constants/permissions';

export interface UiPermissions {
  canViewSites: boolean;
  canEditSites: boolean;
  canDeleteSites: boolean;
  canViewSiteFinancials: boolean;
  canEditSiteFinancials: boolean;

  canViewPlots: boolean;
  canViewPlotLabourItems: boolean;
  canViewPlotFinancials: boolean;

  canViewLabourItems: boolean;
  canSubmitLabourWork: boolean;
  canResubmitLabourWork: boolean;
  canApproveLabourWork: boolean;
  canEditLabourItems: boolean;
  canViewLabourPrices: boolean;
  canEditLabourPrices: boolean;

  canViewUsers: boolean;
  canInviteUsers: boolean;
  canManageUsers: boolean;
  canManageAdmins: boolean;

  canViewOrganisationDetails: boolean;
  canManageOrganisation: boolean;

  isAdmin: boolean;
  isSupervisor: boolean;
  isContractor: boolean;
  canManageFinancials: boolean;
  canViewAllFinancials: boolean;
  isReadOnly: boolean;
}

export const computeUiFlags = (permissions: string[]): UiPermissions => {
  const has = (p: string) => permissions.includes(p);

  return {
    // Site
    canViewSites: has(Permissions.Sites.Read),
    canEditSites: has(Permissions.Sites.Edit),
    canDeleteSites: has(Permissions.Sites.Delete),
    canViewSiteFinancials: has(Permissions.Sites.Financial.Read),
    canEditSiteFinancials: has(Permissions.Sites.Financial.Edit),

    // Plots
    canViewPlots: has(Permissions.Plots.Read),
    canViewPlotLabourItems: has(Permissions.Plots.Labour.Read),
    canViewPlotFinancials: has(Permissions.Plots.Financial.Read),

    // Labour
    canViewLabourItems: has(Permissions.Labour.Read),
    canSubmitLabourWork: has(Permissions.Labour.Submit),
    canResubmitLabourWork: has(Permissions.Labour.Resubmit),
    canApproveLabourWork: has(Permissions.Labour.Approve),
    canEditLabourItems: has(Permissions.Labour.Edit),
    canViewLabourPrices: has(Permissions.Labour.Prices.Read),
    canEditLabourPrices: has(Permissions.Labour.Prices.Edit),

    // Users
    canViewUsers: has(Permissions.Users.Read),
    canInviteUsers: has(Permissions.Users.Invite),
    canManageUsers: has(Permissions.Users.Manage),
    canManageAdmins: has(Permissions.Users.ManageAdmins),

    // Org
    canViewOrganisationDetails: has(Permissions.Organisation.Read),
    canManageOrganisation: has(Permissions.Organisation.Manage),

    // Composite
    isAdmin: has(Permissions.Organisation.Manage) && has(Permissions.Users.Manage),
    isSupervisor: has(Permissions.Labour.Approve) && !has(Permissions.Organisation.Manage),
    isContractor: has(Permissions.Labour.Submit) && !has(Permissions.Labour.Approve),
    canManageFinancials: has(Permissions.Sites.Financial.Edit) && has(Permissions.Labour.Prices.Edit),
    canViewAllFinancials: has(Permissions.Sites.Financial.Read) && has(Permissions.Labour.Prices.Read),
    isReadOnly: !has(Permissions.Sites.Edit) && !has(Permissions.Labour.Edit) && !has(Permissions.Labour.Submit),
  };
};

